<template>
    <div class="service--flight">

        <b-row v-if="flight_service.details.itineraries.length == 0">
            <b-col cols="10" offset="1" class="d-flex align-items-center">
                <font-awesome-icon icon="plus" @click="add_itinerary_to_flight()"/>
                <small><i>Aggiungi un itinerario</i></small>
            </b-col>
        </b-row>

        <div class="service--flight--item" v-if="flight_service.details.itineraries.length > 0">

            <b-row>
                <b-col cols="10" offset="1">
                    <div class="service--flight--panel">
                        <div class="service--flight--head">
                            <div class="toggle service--toggle" v-b-toggle="'service-flight-'+_uid" v-html="chevron_down_toggler"></div>
                            <label>
                                Operativo di volo
                            </label>
                        </div>
                        <b-collapse class="service--collapse" :id="'service-flight-'+_uid">
                            <b-row class="service--flight--itinerary" v-for="( itinerary ) in flight_service.details.itineraries" v-bind:key="'itinerary_'+itinerary.itinerary_index">
                                <b-col cols="10" offset="1">
                                    <div class="d-flex">
                                        <div class="toggle service--toggle" v-b-toggle="'service-'+flight_service.service_index+'-itinerary'+itinerary.itinerary_index" v-html="chevron_down_toggler"></div>
                                        <label class="mb-0 ml-2">
                                            Itinerario {{ itinerary.itinerary_index + 1 }}
                                        </label>
                                    </div>
                                    <b-collapse class="service--flight--segments" :id="'service-'+flight_service.service_index+'-itinerary'+itinerary.itinerary_index">
                                        <div class="service--flight--itinerary--wrapper">

                                            <div v-if="itinerary.segments.length == 0">
                                                <div class="d-flex align-items-center">
                                                    <font-awesome-icon icon="plus" @click="add_segment_to_itinerary(itinerary.itinerary_index)"/>
                                                    <small><i>Aggiungi un segmento</i></small>
                                                </div>
                                            </div>

                                            <div class="service--flight--segment" v-for="( segment ) in itinerary.segments" v-bind:key="'segment_'+segment.segment_index">
                                                <b-row>
                                                    <b-col cols="11">
                                                        <segment-item
                                                            :segment="segment"
                                                            :segment_index="segment.segment_index"
                                                            :itinerary_index="itinerary.itinerary_index"
                                                            v-on:removed="/*remove_segment_from_itinerary*/"
                                                            v-on:updated="update_segment_in_itinerary"
                                                        />
                                                    </b-col>
                                                    <b-col cols="1" class="d-flex align-items-center justify-content-center">
                                                        <font-awesome-icon icon="times" @click="remove_segment_from_itinerary({
                                                            itinerary_index: itinerary.itinerary_index,
                                                            segment_index: segment.segment_index,
                                                        })"/>
                                                        <font-awesome-icon icon="plus" @click="add_segment_to_itinerary(itinerary.itinerary_index)"/>
                                                    </b-col>
                                                </b-row>
                                            </div>
                                        </div>
                                    </b-collapse>
                                </b-col>
                                <b-col cols="1" class="text-center">
                                    <font-awesome-icon icon="times" @click="remove_itinerary_from_flight(itinerary.itinerary_index)"/>
                                    <font-awesome-icon icon="plus" @click="add_itinerary_to_flight()"/>
                                </b-col>
                            </b-row>
                        </b-collapse>
                    </div>
                </b-col>
            </b-row>

        </div>
    </div>
</template>

<script>
import { new_flight_itinerary, new_flight_segment } from '@/quote'
import { parse_flight_offers_duration, parse_flight_offers_date } from '@/utilities'
import { chevron_down_toggler } from '@/components/svg/common'
import Segment from '@/components/blocks/flight/segment'

export default {
    name: 'flight',
    components: {
        'segment-item': Segment,
    },
    props: {
        service: {
            type: Object,
            default: () => {}
        }
    },
    computed:
    {
    },
    data() {
        return {
            flight_service: this.service,
        }
    },
    created()
    {
        this.parse_flight_offers_duration = parse_flight_offers_duration
        this.parse_flight_offers_date = parse_flight_offers_date
        this.new_flight_segment = new_flight_segment
        this.new_flight_itinerary = new_flight_itinerary
        this.chevron_down_toggler = chevron_down_toggler
    },
    mounted() {
    },
    methods:{
        update_service()
        {
            this.$store.commit('set_service', {
                service: this.flight_service
            })
        },
        add_itinerary_to_flight()
        {
            let index = 0
            this.flight_service.details.itineraries.forEach(itinerary => {
                if(itinerary.itinerary_index >= index) index = itinerary.itinerary_index + 1
            })    
            this.flight_service.details.itineraries.push(new_flight_itinerary(index))
            this.update_service()
        },
        remove_itinerary_from_flight(itinerary_index)
        {
            this.flight_service.details.itineraries = this.flight_service.details.itineraries.filter(function(itinerary){
                return itinerary.itinerary_index !== itinerary_index
            })
            this.update_service()
        },
        add_segment_to_itinerary(itinerary_index)
        {
            let index = 0
            this.flight_service.details.itineraries[itinerary_index].segments.forEach(segments => {
                if(segments.segment_index >= index) index = segments.segment_index + 1
            })    
            this.flight_service.details.itineraries[itinerary_index].segments.push(new_flight_segment(index))
            this.update_service()
        },
        update_segment_in_itinerary(payload)
        {
            this.flight_service.details.itineraries[payload.itinerary_index].segments[payload.segment.segment_index] = payload.segment
            this.update_service()
        },
        remove_segment_from_itinerary(payload)
        {
            let _this = this
            let service_from_state = this.$store.state.quote.services.filter(function(service){
                return service.service_index == _this.service.service_index
            })[0]

            let itinerary_from_state = service_from_state.details.itineraries.filter(function(itinerary){
                return itinerary.itinerary_index == payload.itinerary_index
            })[0]

            let updated_segments = itinerary_from_state.segments.filter(function(segment){
                return segment.segment_index !== payload.segment_index
            })

            this.flight_service.details.itineraries[payload.itinerary_index].segments = updated_segments

            this.update_service()
        },
    },
}
</script>

<style lang="scss">
    .service--flight
    {
        .alert
        {
            margin-bottom:0;
        }
        &--panel
        {
            @include subpanel;
        }
        &--head
        {
            display: flex;
            align-items: center;
            label
            {
                min-width: auto;
                margin-left:1rem;
                margin-bottom: 0;
            }
        }
        .collapse
        {
            margin-top:$grid-gutter-width/2;
        }
        &--itinerary
        {
            display: flex;
            .collapse
            {
                flex:1;
            }
            border-radius: $border-radius;
            &:not(:last-child)
            {
                margin-bottom:$grid-gutter-width/2;
            }
            &--badge--wrapper
            {
                width:140px;
            }
            &--badge
            {
                border-radius: 0;
                white-space: normal;
                display: block;
                text-align: center;
            }
            &--wrapper
            {
                display: flex;
                flex-wrap: wrap;
                flex: 1;
            }
            &--remove
            {
                display: block;
                text-align: right;
                margin-left: $grid-gutter-width/2;
            }
        }
        &--segments
        {
            display:flex;
            //border:1px solid rgba($info,0.25);
        }
        &--segment
        {
            width:100%;
            background:rgba($gray-100,1);
            &:not(:last-child)
            {
                margin-bottom:$grid-gutter-width/2;
            }
        }
        .service--flight--itinerary--remove
        {
            text-align: center;
            margin-top:$grid-gutter-width/2;
            margin-right:$grid-gutter-width/2;
        }
        .service--flight--segment--add
        {
            padding:$grid-gutter-width/2;
            text-align: left;
            width:100%;
        }

        [disabled]
        {
            color:$gray-500;
        }
    }
</style>